export default __webpack_public_path__ + "static/banner_1-7e0cee48f6e165b21d124391e02e1074.webp";